import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {QuestionsOverviewComponent} from './questions-overview.component';

const routes: Routes = [
  {path: 'questions', component: QuestionsOverviewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class QuestionsOverviewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-overview/questions-overview-routing.module.ts